// Detects the user's region so AvA can surface FREE local human helplines.
// Supported region keys (must mirror backend app/services/remce.py REFERRALS):
// uk, us, ca, au, ie, nz. Anything else falls back to the international directory.
const LOCALE_MAP = { GB: 'uk', UK: 'uk', US: 'us', CA: 'ca', AU: 'au', IE: 'ie', NZ: 'nz' };

const TZ_MAP = [
  [/^Europe\/London$/, 'uk'],
  [/^Europe\/(Dublin)$/, 'ie'],
  [/^Australia\//, 'au'],
  [/^Pacific\/(Auckland|Chatham)$/, 'nz'],
  [/^America\/(Toronto|Montreal|Vancouver|Edmonton|Winnipeg|Halifax|St_Johns|Regina|Moncton|Whitehorse|Yellowknife|Iqaluit)$/, 'ca'],
  [/^America\//, 'us'],
  [/^Pacific\/Honolulu$/, 'us'],
];

export function detectRegion() {
  try {
    const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const lang of langs) {
      const sub = (lang || '').split('-')[1]?.toUpperCase();
      if (sub && LOCALE_MAP[sub]) return LOCALE_MAP[sub];
    }
  } catch { /* fall through */ }
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    for (const [re, region] of TZ_MAP) {
      if (re.test(tz)) return region;
    }
  } catch { /* fall through */ }
  return 'international';
}

export default detectRegion;
